import { M8PartnerClientsOnMonth } from 'services/production/types';
import { PartnerClientsTableGroup } from 'types/partnerClientsTable';
import { normalizeM8DateString } from './normalizeM8DateString';
import { normalizeM8PartnerClientsOnMonthClientDTO } from './normalizeM8PartnerClientsOnMonthClientDTO';

export const normalizeM8PartnerClientsOnMonthDTO = (
  m8PartnerClientOnMonthDTO: M8PartnerClientsOnMonth
) => ({
  toPartnerClientsTableGroup(): PartnerClientsTableGroup {
    const monthDateISO = normalizeM8DateString(
      m8PartnerClientOnMonthDTO.monthFor
    )
      .toDate()
      .toISOString();

    const totalIncome = m8PartnerClientOnMonthDTO.totalIncome;
    const licensesCount = m8PartnerClientOnMonthDTO.licensesCount;
    const subscriptionsCount = m8PartnerClientOnMonthDTO.clientsCount;

    return {
      monthDateISO,
      totalIncome,
      licensesCount,
      subscriptionsCount,
      items: m8PartnerClientOnMonthDTO.clients.map((client) =>
        normalizeM8PartnerClientsOnMonthClientDTO(
          client
        ).toPartnerClientsTableItem()
      ),
    };
  },
});
